import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

export function PartyPhotoUpload({ endpoint, name, photo, onDone, size = "w-16 h-16", testid }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  async function pick(e) {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post(endpoint, fd);
      onDone(data.photo_url);
      toast.success("Profile photo updated");
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  }
  return (
    <>
    <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); ref.current?.click(); }}
      className={`relative ${size} rounded-full bg-[var(--bg-warm)] overflow-hidden flex items-center justify-center group shrink-0`} aria-label={`Change photo for ${name}`} data-testid={testid}>
      {photo ? <img src={photo} alt="" className="w-full h-full object-cover" /> : <span className="font-serif text-2xl text-[var(--gold)]">{(name || "?")[0]?.toUpperCase()}</span>}
      <span className={`absolute inset-0 bg-black/45 flex items-center justify-center text-white transition-opacity ${busy ? "opacity-100" : "opacity-0 group-hover:opacity-100"}`}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Camera className="w-4 h-4" />}
      </span>
    </button>
    <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" hidden onChange={pick} onClick={(e) => e.stopPropagation()} data-testid={testid ? `${testid}-input` : undefined} />
    </>
  );
}
